import { ItemType } from 'src/models/dto/items/ItemDTO'
import {
    defaultWritingExerciseItemDTO,
    WritingExerciseItemDTO,
} from 'src/models/dto/items/WritingExerciseItemDTO'
import { Locale } from 'src/models/dto/Locale'
import { factories, ITEM_ENTITY_STORE_SELECTOR } from '../ItemEntityService'
import { Stores } from './../../Store'

const itemType = ItemType.WritingExercise

export class WritingExerciseHandler {
    static init() {
        // add the create function to the set of factories available in ItemEntityService
        factories.set(itemType, () => WritingExerciseHandler.create())
    }

    private static store() {
        return Stores.get<WritingExerciseItemDTO>(ITEM_ENTITY_STORE_SELECTOR)
    }

    static create(): WritingExerciseItemDTO {
        return defaultWritingExerciseItemDTO()
    }

    private static assign(id: string, obj: Partial<WritingExerciseItemDTO>) {
        this.store().assign(id, obj)
    }

    static updateLabel(id: string, label: string) {
        this.assign(id, { label })
    }

    static updateOptional(id: string, optional: boolean) {
        this.assign(id, { optional })
    }

    static updatePreserveOrder(id: string, preserveOrder: boolean) {
        this.assign(id, { preserveOrder })
    }

    static updateTitle(id: string, locale: Locale, nextValue: string) {
        this.store().produce(id, (entity) => {
            entity.titleI18N[locale] = nextValue
        })
    }

    static updateInstruction(id: string, locale: Locale, nextValue: string) {
        this.store().produce(id, (entity) => {
            entity.instructionI18N[locale] = nextValue
        })
    }

    static updateMinWordsAllowed(id: string, minCharacterLimit: number | null) {
        this.assign(id, { minWordLimit: minCharacterLimit ?? undefined })
    }

    static updateWordLimit(id: string, characterLimit: number | null) {
        this.assign(id, { wordLimit: characterLimit ?? 0 })
    }
}
